import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { getData } from 'features/dinamic';

interface FacilitadorAlumnoState {
  statusGrupo: string;
  statusAlumno: string;
  error: string;
  detalleGrupo: any | null;
  alumnos: any[];
  detalleAlumno: any | null;
}

const initialState: FacilitadorAlumnoState = {
  statusGrupo: 'idle',
  statusAlumno: 'idle',
  error: '',
  detalleGrupo: null,
  alumnos: [],
  detalleAlumno: null,
};

export const fetchAlumnosGrupo = createAsyncThunk(
  'facilitador/fetchAlumnosGrupo',
  async ({ idGrupo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 146;
    const { result, message, data } = await getData({ idsp, idGrupo }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

export const fetchDetalleAlumno = createAsyncThunk(
  'facilitador/fetchDetalleAlumno',
  async ({ idGrupo, idUsuarioAlumno }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 147;
    const { result, message, data } = await getData({ idsp, idGrupo, idUsuarioAlumno }, getState, dispatch);
    if (result) {
      return { data };
    }
    return rejectWithValue(message);
  }
);

const facilitadorAlumnoSlice = createSlice({
  name: 'facilitadorAlumno',
  initialState,
  reducers: {
    clearDetalleGrupo: (state) => {
      state.detalleGrupo = null;
      state.alumnos = [];
      state.statusGrupo = 'idle';
      state.error = '';
    },
    clearDetalleAlumno: (state) => {
      state.detalleAlumno = null;
      state.statusAlumno = 'idle';
      state.error = '';
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAlumnosGrupo.pending, (state) => {
        state.statusGrupo = 'loading';
      })
      .addCase(fetchAlumnosGrupo.fulfilled, (state, action) => {
        state.statusGrupo = 'completed';
        const data = action.payload.data || null;
        state.detalleGrupo = data;
        state.alumnos = Array.isArray(data?.alumnos) ? data.alumnos : [];
      })
      .addCase(fetchAlumnosGrupo.rejected, (state, action) => {
        state.statusGrupo = 'failed';
        state.error = action.payload as string;
      })
      .addCase(fetchDetalleAlumno.pending, (state) => {
        state.statusAlumno = 'loading';
      })
      .addCase(fetchDetalleAlumno.fulfilled, (state, action) => {
        state.statusAlumno = 'completed';
        const data = action.payload.data;
        state.detalleAlumno = Array.isArray(data) ? data[0] : data || null;
      })
      .addCase(fetchDetalleAlumno.rejected, (state, action) => {
        state.statusAlumno = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const selectFacilitadorDetalleGrupo = (state: RootState) => state.facilitadorAlumno.detalleGrupo;
export const selectFacilitadorAlumnosGrupo = (state: RootState) => state.facilitadorAlumno.alumnos;
export const selectFacilitadorDetalleAlumno = (state: RootState) => state.facilitadorAlumno.detalleAlumno;
export const selectFacilitadorDetalleGrupoStatus = (state: RootState) => state.facilitadorAlumno.statusGrupo;
export const selectFacilitadorDetalleAlumnoStatus = (state: RootState) => state.facilitadorAlumno.statusAlumno;

export const { clearDetalleGrupo, clearDetalleAlumno } = facilitadorAlumnoSlice.actions;

export default facilitadorAlumnoSlice.reducer;
